import { GET, PUT, omsBaseUrlApi } from '@constants/generic-constants.js';
import NetworkManager from '../../services/network-service.js';
import { convertQueryObjToString } from '../../components/web-view/filters/helper';
import { POST } from '../../constants/generic-constants.js';
import PermissionsHelper from '../../auth/helper/PermissionHelper.js';
import {
  ACTION_INDEX,
  ACTION_SHOW,
  ACTION_TRANSACTION_HISTORY,
  PERMISSION_KEY_ORDER,
} from '../../constants/permission-constants.js';
import { ACCESS_DENIED } from '../../constants/seller-center-paths.js';
import { redirectToPath } from '../../utils/utils.js';

export const ordersListingApi = (params = '') => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_ORDER, ACTION_INDEX)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    let url = `${omsBaseUrlApi}/orders${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const transactionListingApi = (params = '') => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_ORDER, ACTION_TRANSACTION_HISTORY)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    let url = `${omsBaseUrlApi}/orders/transaction_history${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const orderDetailApi = (id = '') => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_ORDER, ACTION_SHOW)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    let url = `${omsBaseUrlApi}/orders/${id}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateOrderStatusApi = (params = '', payload = {}) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/orders${params}`;
    NetworkManager.performRequest(url, payload, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const acceptLineItemsApi = (id, body, extraParams) => {
  return new Promise((resolve, reject) => {
    NetworkManager.performRequest(extraParams?.url, body, extraParams?.method)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createShipmentApi = (id, body) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/orders/${id}/create_consignment`;
    NetworkManager.performRequest(url, body, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const removeItemApi = (id, body) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/orders/${id}/remove_line_item`;
    NetworkManager.performRequest(url, body, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getRemovalReasonsApi = (params = '') => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/reasons${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const cancelOrderApi = (id, body) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/orders/${id}/cancel_order`;
    NetworkManager.performRequest(url, body, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const confirmPickupApi = (id) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/consignments/${id}/awaiting_rider_collection`;
    NetworkManager.performRequest(url, null, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const dispatchOrderApi = (id) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/consignments/${id}/dispatched`;
    NetworkManager.performRequest(url, null, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const markAsDeliveredApi = (id) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/consignments/${id}/delivered`;
    NetworkManager.performRequest(url, null, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const markAsReturnedApi = (id, body) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/consignments/${id}/returned`;
    NetworkManager.performRequest(url, body, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const handleBulkActionApi = (body, extraParams) => {
  return new Promise((resolve, reject) => {
    let url = extraParams?.url ?? `${omsBaseUrlApi}/orders/accept_orders`;
    NetworkManager.performRequest(url, body, extraParams?.method ?? PUT, null, extraParams?.responseType)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createShipmentsBulkApi = (body) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/orders/create_shipments`;
    NetworkManager.performRequest(url, body, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const confirmPickupBulkApi = (body) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/consignments/confirm_shipments`;
    NetworkManager.performRequest(url, body, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateOrderAddressApi = (id = '', body = {}) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/orders/${id}/update_address`;
    NetworkManager.performRequest(url, body, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const orderActionApi = ({ url = '', method = '', data = null, responseType }) => {
  return new Promise((resolve, reject) => {
    NetworkManager.performRequest(url, data, method, undefined, responseType)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateStatus = ({ body, method, url }) => {
  return new Promise((resolve, reject) => {
    NetworkManager.performRequest(url, body, method)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const fetchOrderFulfillmentApi = () => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/settlements/payments_summary`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const returnOrdersListingApi = (params = '') => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_ORDER, ACTION_INDEX)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    let url = `${omsBaseUrlApi}/returns${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const returnOrderDetailApi = (id = '') => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_ORDER, ACTION_SHOW)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    let url = `${omsBaseUrlApi}/returns/${id}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
